module.exports = __webpack_public_path__ + "static/Micropayments-f79b356eada087f5ccb7874d51faedc4.png";